const dialog = document.getElementById("dialog");
const productDetails = document.getElementById("productDetails");
const position = document.getElementById("dialogPosition");
const optionSelectors = document.getElementById("optionSelectors");
const body = document.body;

const showDialog = () => {
  body.appendChild(dialog);
  const scrollY = window.scrollY + "px";
  body.style.position = "fixed";
  body.style.top = `-${scrollY}`;
  setTimeout(function () {
    dialog.classList.add("show");
  }, 100);
};
const closeDialog = () => {
  const scrollY = body.style.top;
  body.style.position = "";
  body.style.top = "";
  window.scrollTo(0, parseInt(scrollY || "0") * -1);
  dialog.classList.remove("show");
  setTimeout(function () {
    productDetails.insertBefore(dialog, position);
  }, 300);
};
// window.addEventListener('scroll', () => {
//   document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
// });

const showDialogButton = document.getElementById("showDialog");
if (showDialogButton) {
  const closeDialogButtons = [
    document.getElementById("dialogCloseIcon"),
    document.getElementById("dialogCloseText"),
  ];
  showDialogButton.addEventListener("click", () => {
    showDialog();
  });
  closeDialogButtons.forEach((e) => {
    e.addEventListener("click", () => {
      closeDialog();
    });
  });
}

// window.onload = function () {
//   const thisSwiper = Object.values(window.theme.swipers)[0];
//   const smlImgs = document.querySelectorAll(".product_form__images");
//   smlImgs.forEach((img) => {
//     const i = img.getAttribute("data-position") - 1;
//     img.addEventListener("click", function () {
//       thisSwiper.slideTo(i, 500);
//     });
//   });
// };
